import { render, staticRenderFns } from "./Discount_Form.vue?vue&type=template&id=5ec97596&scoped=true&"
import script from "./Discount_Form.vue?vue&type=script&lang=js&"
export * from "./Discount_Form.vue?vue&type=script&lang=js&"
import style0 from "./Discount_Form.vue?vue&type=style&index=0&id=5ec97596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec97596",
  null
  
)

export default component.exports